module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#user",
      toString: function () {
        return this.url;
      }
    }